<template>
  <div>
    <!-- 卡片列表 -->
    <div v-loading="loading"
         class="card-prodlist">
      <div class="card-prod"
           :style="cardSize"
           v-for="(o, index) in itemList"
           :key="index">
        <el-card shadow="hover"
                 :body-style="{ padding: '0px' }">
          <div class="content_image">
            <img class="image"
                 :style="imageSize"
                 @click="clickCard(o)"
                 :src="o.image" />
            <div v-if="o.corner_name!==''"
                 class="content_dest_corner">{{o.corner_name}}</div>
            <!-- 二维码 -->
            <div class="hover_image">
              <show-qr-code :size="100"
                            :code="o.id"
                            type="traverReview"></show-qr-code>
            </div>
          </div>
          <!-- 内容盒子 -->
          <div style="padding: 14px">
            <!-- 产品标题:有2行，超过之后用... 显示 -->
            <div @click="clickCard"
                 style=" width: 200px;">
              <h3 class="card-first-title">
                {{ o.title }}
              </h3>
              <!-- 下标题 -->
              <div style="color: grey;width: 200px; height: 50px">
                <span v-if="o.title_mini"
                      style="font-size: 5px;">{{titleMiniName}}</span>
                <span class="under-title"
                      v-html="o.title_mini.length > 28 ? o.title_mini.slice(0, 28) + '...' :o.title_mini">
                </span>
              </div>
            </div>
            <!-- 标签 -->
            <div v-if="showTag">
              <span style="font-size: 13px">分类:</span>
              <el-tag style="margin-left: 5px"
                      size="mini">
                {{o.class_name}}
              </el-tag>
            </div>
            <!-- 目的地 -->
            <div v-if="showDest">
              <span style="font-size: 13px">目的地:</span>
              <el-tag style="margin-left: 5px"
                      v-for="(locitem, index) in o.dest"
                      :key="index"
                      size="mini"
                      type="info">{{ locitem }}</el-tag>
            </div>

            <div class="bottom-item">
              <!-- 更新于日期 -->
              <div v-if="showUpdate"
                   class="time">更新于: {{ o.update_time }}</div>

              <el-button v-if="showButton"
                         @click="makeResveration(o)"
                         type="text"
                         class="button">{{buttonName}}</el-button>
            </div>
          </div>
        </el-card>
      </div>
      <!-- 通过判断itemList补充块 -->
      <div class="card-prod-none"
           v-if="this.cardList.length/4==1"></div>
      <div class="card-prod"
           :style="cardSize"
           v-else-if="(this.cardList.length-2)/4==0||1"
           v-for="(i,index) in ['a','b']"
           :key="index+4.1"></div>
      <div class="card-prod"
           :style="cardSize"
           v-else-if="(item,index) in ['a','b','c']"
           :key="index+4.8"
           v-show="(this.cardList.length-1)/4==0||1">
      </div>
    </div>
  </div>
</template>

<script>
import showQRcode from '../other/hoverShowQRcode.vue'

export default {
  name: 'card-list-component',
  components: {
    'show-qr-code': showQRcode,
  },
  data() {
    return {
      cardSize: `width:${this.cardWidth}`,
      imageSize: `  height: ${this.imageHeight}px; width: 100%;`,
      loading: false,
      itemList: this.cardList,
    }
  },
  watch: {
    cardList(newVal) {
      this.itemList = newVal
    },
  },
  props: {
    cardList: {
      type: Array,
      default: () => {
        return []
      },
    },
    titleMiniName: {
      type: String,
      default: '下标题名称:',
    },
    // 显示功能区
    showTitleImage: {
      type: Boolean,
      default: true,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    buttonName: {
      type: String,
      default: '按钮',
    },
    showDest: {
      type: Boolean,
      default: true,
    },
    showTag: {
      type: Boolean,
      default: true,
    },
    showUpdate: {
      type: Boolean,
      default: true,
    },
    // 卡片大小
    cardWidth: {
      type: String,
      default: '23%',
    },
    // 图片设置
    imageHeight: {
      type: Number,
      default: 235,
    },
    imageWidth: {
      type: Number,
      default: 235,
    },
  },
  methods: {
    clickCard(value) {
      this.$emit('clickCard', value)
    },

    makeResveration(value) {
      this.$emit('clickButton', value)
    },
  },
}
</script>

<style>
.content_image {
  position: relative;
}
/* 基本 */
.image {
  display: block;
  cursor: pointer;
}
/* 封面元素 */
.content_dest_corner {
  position: absolute;
  font-size: 13px;
  color: #fff;
  padding: 0 10px;
  background-color: #ff5421;
  /* width: 30%; */
  top: 0%;
  left: 0%;
}

.hover_image {
  display: none;
}

.content_image:hover .hover_image {
  display: block;
  position: absolute;
  font-size: 13px;
  /* padding: 0 10px; */
  /* background-color: #fff; */
  /* width: auto; */
  top: 10%;
  right: 10%;
}
.button {
  padding: 0;
  float: right;
}
/* 卡片 */
.card-prodlist {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  justify-content: space-between;
  align-items: flex-start;
}
.card-prod {
  margin: 5px;
  /* margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  margin-left: 10px; */
  /* cursor 光标属性，可以添加click事件 */
}
.card-first-title {
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.bottom-item {
  display: flex;
  margin-top: 5px;
  justify-content: space-between;
}
.under-title {
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>